import { createFileRoute } from '@tanstack/react-router';

import { PatientDetailPage } from '@/features/emr/pages/PatientDetailPage';

export const Route = createFileRoute('/_authenticated/patients/$patientId')({
  component: PatientDetailPage,
  validateSearch: (search: Record<string, unknown>): { assistant?: boolean; tab?: 'details' | 'midwifery' } => ({
    tab: search.tab === 'details' || search.tab === 'midwifery' ? search.tab : undefined,
    assistant: search.assistant === true || search.assistant === 'true' ? true : undefined,
  }),
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/patients', title: 'Patients' }, { title: 'Patient Detail' }],
  }),
});
